/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import metadata from './PropertyDetailsAccordion.metadata.json5';
import styles from './PropertyDetailsAccordion.module.scss'
import { useTranslator } from '@jutro/locale';

const PropertyDetailsAccordion = props => {
    const {
        policyDetailsData, lobData_TWIA, policyTransactionDetails, producerOfServiceValue,
        producerOfRecordValue, isDwelling,
        isTenant,
        isMH,
        isApartmentOrCondo
    } = props;
    const translator = useTranslator();
    const mortgageeData = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.mortgageeDetailsDTO');

    // DE17811
    const structureTypeValue = () =>{
        const structureTypeCode = _.get(lobData_TWIA,'homeOwners.dwellingDTO.homeDetails.structureType_TWIA')
        const structureType = translator({
            id: `typekey.StructureType_TWIA.${structureTypeCode}`,
            defaultMessage: structureTypeCode,
        });
        return structureType
    }

    const costalZoneValue = () =>{
        const costalZoneCode = _.get(lobData_TWIA,'homeOwners.dwellingDTO.homeDetails.coastalZoneType_TWIA')
        const costalZone = translator({
            id: `typekey.CoastalZoneType_TWIA.${costalZoneCode}`,
            defaultMessage: costalZoneCode,
        });
        return costalZone
    }
    
    const generateOverrides = useCallback(() => {
        if (!_.isUndefined(mortgageeData)) {

            const overrides = mortgageeData.map((item, index) => {
                return {
                    [`mortgageeValue${index}`]: {
                        content: <div className={styles.container}>
                            <div className={styles.header}>
                                <span>Name</span>
                                <span>Street</span>
                                <span>City</span>
                                <span>State</span>
                            </div>
                            <div className={styles.row}>
                                <span>{item.name}</span>
                                <span>{item.street}</span>
                                <span>{item.city}</span>
                                <span>{item.state}</span>
                            </div>
                        </div>
                    },
                };
            });

            return Object.assign({}, ...overrides);
        }

    }, [mortgageeData]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {           
            className:styles.fieldStyle
        },
        structureType: {
            visible: !isMH,
            value:structureTypeValue()
        },
        homeUsedAs: {
            visible: !isMH
        },
        mailingAddressDetails: {
            visible: !isMH
        },
        nameOfComplex: {
            visible: isApartmentOrCondo
        },
        unitNumber: {
            visible: isApartmentOrCondo
        },
        building: {
            visible: isApartmentOrCondo
        },
        mortagageeSection: {
            data: mortgageeData
        },
        mortgageeDetails: {
            visible: !_.isUndefined(mortgageeData) && !_.isEmpty(mortgageeData)
        },
        coastalZone:{
            value: costalZoneValue()
        },
        ...generateOverrides()
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={lobData_TWIA}
            // callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        // componentMap={resolvers.resolveComponentMap}
        />
    );
};


PropertyDetailsAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}),
};
export default PropertyDetailsAccordion;
